import getUserInfo from './getInfo'
import getUserAuth from './getAuth'
import startAuthCheck from './checkAuth'
import { getJumpSwitchConfig } from './getSwitch'
import getAvayaUserWhiteList from './getAvayaUserWhiteList'
import parseMenuData from './parse'
import { Loading } from 'element-ui'
import { CONST, errorHandler, login, logout } from './depends'
import * as Sentry from '@/extend/sentry'
/**
 * 运满满登录和路由鉴权
 */
const namespace = 'Authentication'
// 注册store
export function afterStoreCreate(store, { registerStore }) {
  registerStore({
    namespace,
    state: {
      user: null,
      auth: []
    },
    getters: {
      UserInfo: state => state
    },
    mutations: {
      save(state, payload) {
        localStorage.__userInfo = JSON.stringify(payload.user)
        Object.assign(state, payload)
      }
    },
    actions: {
      login,
      logout
    },
    subscribe: {
      [`${namespace}/save`]($store, payload) {
        // console.log({ $store, payload }, '$store, payload')
        // 获取到用户信息后，对电话工作台本地缓存做清理操作
        $store.commit('caller/cuttingListByLength', {
          user: payload.user,
          options: [{ stateKey: 'in', localKey: 'callInLocalKey', splitLength: 200 }]
        })
      }
    }
  })
}
// 在app创建前先鉴权，通过才启动app
export async function beforeAppCreate({ router, store }) {
  const loading = Loading.service({ fullscreen: true })
  try {
    const user = await getUserInfo()
    if (!user) return
    const userAuth = await getUserAuth()
    if (!userAuth) throw -1
    const { userMenus = [], auth = [] } = userAuth || {}
    const menuData = parseMenuData(userMenus)
    store.commit('app/RESET_MENUS', { menus: menuData.menus })
    const jumpSwitchConfig = await getJumpSwitchConfig()
    getAvayaUserWhiteList()
    //const menuData = parseMenuData(auth)
    router && startAuthCheck(router, auth, { jumpSwitchConfig, user })
    if (store) {
      store.commit('app/setPowers', { menus: menuData.codeMap })
      store.commit('app/setJumpSwitchConfig', jumpSwitchConfig)
      store.commit(`${namespace}/save`, { user, auth })
    }
    // 全局为sentry事件添加 user
    // 其中 user 可以设置的信息包括 id 、 username 、 ip_address 、email
    Sentry.setUser({ id: user.id })

    window?.Cookies?.set?.('userId', user?.jobNumber || '')
    window?.Cookies?.set?.('departmentId', user?.departmentId || '')
  } catch (e) {
    if (e !== -1) {
      errorHandler(CONST.initError)
    }
    throw e
  } finally {
    loading.close()
  }
}
